"use client";

import { useState, useEffect } from "react";
import { Button } from "@workspace/sc-ui/components/button";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";
import { cn } from "@workspace/sc-ui/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@workspace/sc-ui/components/tooltip";

interface ToggleThemeProps {
  className?: string;
}

export const ToggleTheme = ({ className }: ToggleThemeProps) => {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();
  const t = useTranslations("app.theme");
  const tTooltip = useTranslations("app.tooltip");

  // Odczyt rzeczywistego motywu dopiero po hydratacji, także przy ustawieniu systemowym.
  useEffect(() => {
    setMounted(true);
  }, []);

  // Podczas SSR pokazuj neutralny tekst aby uniknąć layout shift
  const ready = mounted && Boolean(resolvedTheme);
  const isLight = resolvedTheme === "light";
  const buttonText = !ready ? t("light") : isLight ? t("dark") : t("light");
  const ariaLabel = !ready
    ? tTooltip("theme")
    : isLight
      ? tTooltip("switchToDark")
      : tTooltip("switchToLight");

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          className={cn(className)}
          variant="outline"
          disabled={!ready}
          onClick={() => setTheme(isLight ? "dark" : "light")}
          aria-label={ariaLabel}
          aria-pressed={ready ? !isLight : undefined}
        >
          {buttonText}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tTooltip("theme")}</p>
      </TooltipContent>
    </Tooltip>
  );
};
